import type { MouseEvent } from "react";

import { cx, styled } from "simplydo/react/styled";

import { H3 } from "../header";
import type { CheckboxSlotProps } from "./Checkbox.types";
import { useCheckboxContext } from "./CheckboxContext";

const HeaderEl = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25em;
  font-family: inherit;
  font-weight: bold;
  /* Avoid stacking line-height leading on top of flex centering */
  line-height: 1;
  height: auto;
  margin: 0;
  overflow: visible;
  cursor: pointer;

  /* Nested headings should not break first-line alignment with the control */
  & :is(h1, h2, h3, h4, h5, h6) {
    display: inline-flex;
    align-items: center;
    gap: 0.6em;
    margin: 0 !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
  }

  .is-disabled & {
    cursor: default;
  }
`;

const CheckboxHeaderComponent = (props: CheckboxSlotProps) => {
  const { children, className, style } = props;
  const { disabled, toggle } = useCheckboxContext();

  const handleClick = (event: MouseEvent) => {
    if (disabled) {
      return;
    }
    event.stopPropagation();
    toggle();
  };

  return (
    <HeaderEl className={cx(className)} style={style} onClick={handleClick}>
      <h4>{children}</h4>
    </HeaderEl>
  );
};

export const CheckboxHeader = styled(CheckboxHeaderComponent)``;
CheckboxHeader.displayName = "CheckboxHeader";
